import { formatDateWithoutTimezone } from "../../../utils/dateFormatter";
import { Row } from "../../../modules/storage/models/storage-dto";
import { InitialValues } from "../models/types";

export function buildInitialValues(
  data: Row,
  isDischarge: boolean
): InitialValues {
  return {
    volumeRequested: data.volumeRequested,
    distributionChannel: data.distributionChannel,
    scheduleDate: data.scheduleDate,
    scheduleTime:
      data.scheduleTime ||
      formatDateWithoutTimezone(data.scheduleDate, "HH:mm"),
    orderDate: new Date().toISOString(),
    note: data?.customerRequesterNote ?? "",
    ...(isDischarge
      ? {
          unitPrice: data.unitPrice,
          orderNumber: data.orderNumber,
          orderSeries: data.orderSeries,
        }
      : {
          referenceDocument: data.referenceDocument,
          orderNumberAndSeries:
            data.orderNumber && data.orderSeries
              ? `${String(data.orderNumber)}-${String(data.orderSeries)}`
              : undefined,
        }),
  };
}
